// This icon file is generated automatically.
var PFunnelPlotOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.75 1.4H1.25a.5.5 0 00-.43.76l3.63 6.33v3.6c0 .28.22.5.5.5h4.1a.5.5 0 00.5-.5V8.5l3.63-6.33a.5.5 0 00-.43-.75zM8.43 11.48H5.57V9.16h2.86v2.3zm.15-3.54l-.13.23h-2.9l-.13-.23-1.2-2.09h5.56l-1.2 2.09zm1.77-3.09h-6.7l-1.33-2.3h9.36l-1.33 2.3z", "fill-rule": "nonzero" } }] }, "name": "p-funnel-plot", "theme": "outlined" };
export default PFunnelPlotOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PFunnelPlotOutlined.js
// module id = 3436
// module chunks = 0